import React, { useState } from "react";
import cx from "classnames";
import { useRemoveItemFromCart, client } from "src/context/storeContext";
import { Image } from "src/components/image";
import { Price } from "src/components/price";

import * as styles from "./line-item.module.css";

export const LineItem = ({ item }) => {
  const removeFromCart = useRemoveItemFromCart();

  const [stateQuantity, setQuantity] = useState(item.quantity);

  const { id, title, quantity, variant, customAttributes } = item;

  const {
    title: variantTitle,
    price,
    compareAtPrice,
    image,
    selectedOptions,
  } = variant;

  const itemImage =
    image &&
    client.image.helpers.imageForSize(image, {
      maxWidth: 368,
      maxHeight: 368,
    });

  return (
    <div className={styles.lineItem}>
      <div className={styles.thumbnail}>
        {itemImage && (
          <Image
            className={styles.thumbnailImage}
            src={itemImage}
            alt={title}
            style={{
              objectFit: "cover",
              height: "100%",
            }}
          />
        )}
      </div>
      <div className={styles.details}>
        <div>
          <p className={styles.productTitle}>{title}</p>
          {selectedOptions?.length &&
            selectedOptions.map((option) => {
              if (option.value != "Default Title") {
                return (
                  <p className="caption" key={option.name}>
                    {option.name}:{" "}
                    <span className="italic">{option.value}</span>
                  </p>
                );
              }
            })}
          {customAttributes?.length > 0 &&
            customAttributes.map((attribute, i) => {
              return (
                <p className="caption" key={i}>
                  {attribute.key}:{" "}
                  <span className="italic">{attribute.value}</span>
                </p>
              );
            })}
          <p className="caption">
            Quantity: <span className="italic">{stateQuantity}</span>
          </p>
        </div>

        <button
          type="reset"
          className={cx("reset", styles.remove)}
          onClick={() => removeFromCart(id)}
        >
          <span className="label-italic c-gold underline-on-hover">Remove</span>
        </button>
      </div>
      <div className={styles.pricing}>
        {compareAtPrice && (
          <span className={cx(styles.compareAtPrice)}>
            ${compareAtPrice.amount * stateQuantity}
          </span>
        )}
        <span className={cx("italic", styles.price)}>
          <Price price={price.amount * stateQuantity} />
        </span>
      </div>
    </div>
  );
};
